/* @flow */

import * as React from 'react';
import glamorous from 'glamorous';

type Props = {
  children: React.Node,
  initial?: boolean,
  onClick?: () => void,
  size?: 'large' | 'medium' | 'small' | 'tiny',
  sortDir?: 'asc' | 'desc'
};

const defaultProps = {
  initial: false,
  onClick: undefined,
  size: 'small',
  sortDir: undefined
};

const Wrapper = glamorous.span(props =>
  props.initial
    ? {
        flexBasis: 'auto',
        flexGrow: 1,
        flexShrink: 0,
        textAlign: 'left'
      }
    : {
        flexGrow: 0,
        flexShrink: 0,
        textAlign: 'center'
      }
);

const Cell = glamorous('button', {
  filterProps: ['size', 'sortDir'],
  forwardProps: ['onClick'],
  withProps: {
    type: 'button'
  }
})(props => ({
  alignItems: 'center',
  border: 0,
  display: 'flex',
  justifyContent: 'center',
  outline: 0,
  padding: '0.375em 0.5em',
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
  width: {
    small: '3.5rem',
    medium: '4.5rem',
    large: '5.5rem',
    tiny: '1.5rem'
  }[props.size],
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.5)'
  }
}));

const SortIndicatorWrapper = glamorous.div({
  paddingLeft: 3
});

function TableListCell({ children, initial, onClick, size, sortDir }: Props) {
  return (
    <Wrapper initial={initial}>
      <Cell onClick={onClick} size={size}>
        {children}
        <SortIndicatorWrapper>
          {sortDir && (
            <span
              className={
                {
                  asc: 'ion-arrow-up-b',
                  desc: 'ion-arrow-down-b'
                }[sortDir]
              }
            />
          )}
        </SortIndicatorWrapper>
      </Cell>
    </Wrapper>
  );
}

TableListCell.defaultProps = defaultProps;

export default TableListCell;
